import React from "react";
import { Col } from "react-bootstrap";

import "./style.scss";

export const Circle = ({item}) => {

    return(
        <Col sm={1} md={2} className="circle-wrapper">
          <a 
            className="circle"  
            href={`/node/${item && item.nid}`} 
            target="_blank">
          </a>
        </Col>
    )
}